/**
 * Get the container-class depending on the current colPos-property.
 * If the module is slotted, the colPos is >= 200; if it is used as a subcomponent, the colPos is likely undefined.
 * @param colPos the colPos-property of the current element
 * @returns nothing if the container-class is slotted (i.e. added inside another module); otherwise the container class
 */
export const getColPosContainer = (colPos: number | undefined): string =>
  typeof colPos === "undefined" || colPos >= 200 ? "" : "container";
